import React from "react";
import { Grid2 } from "@mui/material";
import { FundamentalsCard } from "../FundamentalsCard";
import { DividendsChart } from "../DividendsChart/DividendsChart";
import { RanksAndRisks } from "../RanksAndRisks";

export interface Props {
  isin: string;
  currency?: string;
  areDividendsPresent?: boolean;
}

export const FundFundamentalsByIsin = ({
  isin,
  currency,
  areDividendsPresent = false,
}: Props) => (
  <Grid2 container spacing={4} width="100%" mt={5}>
    {areDividendsPresent && (
      <FundamentalsCard>
        <DividendsChart isin={isin} currency={currency} />
      </FundamentalsCard>
    )}

    <FundamentalsCard>
      <RanksAndRisks isin={isin} />
    </FundamentalsCard>
  </Grid2>
);
